"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SevenKGateway = void 0;
const sdk_ts_1 = require("@7kprotocol/sdk-ts");
const transactions_1 = require("@mysten/sui/transactions");
const alphafi_sdk_1 = require("@alphafi/alphafi-sdk");
class SevenKGateway {
    constructor() {
        const suiClient = (0, alphafi_sdk_1.getSuiClient)();
        (0, sdk_ts_1.setSuiClient)(suiClient);
    }
    async getQuote(options) {
        const { pair, inAmount } = options;
        if (inAmount) {
            const quoteResponse = await (0, sdk_ts_1.getQuote)({
                tokenIn: pair.coinA.type,
                tokenOut: pair.coinB.type,
                amountIn: inAmount.toString(),
            });
            return quoteResponse;
        }
    }
    // getTransactionBlock returns a transaction and also returns a coinOut argument which is some coins left out that we have to transfer to the user seperately.
    async getTransactionBlock(options, quoteResponse, transaction = undefined) {
        let txb = new transactions_1.Transaction();
        const { senderAddress, slippage } = options;
        if (transaction)
            txb = transaction;
        const commissionPartnerAddress = "0x401c29204828bed9a2f9f65f9da9b9e54b1e43178c88811e2584e05cf2c3eb6f";
        const { tx, coinOut } = await (0, sdk_ts_1.buildTx)({
            quoteResponse,
            accountAddress: senderAddress,
            slippage: slippage / 100, // 1%
            commission: {
                partner: commissionPartnerAddress,
                commissionBps: 0,
            },
            extendTx: {
                tx: txb,
            },
        });
        return { tx: txb, coinOut };
    }
}
exports.SevenKGateway = SevenKGateway;
//# sourceMappingURL=7k.js.map